import { configureStore } from "@reduxjs/toolkit";
import GeneralSlice from "../General/Store/GeneralSlice";
import ChartSlice from "../scenes/Organization/Chart/ChartSlice/ChartSlice";
import UserSlice from "../scenes/OrganizationDefinitions/CreateUserAccount/Components/userSlice/UserSlice";
import loggingMiddleware from "../middleware";
import schedulerSlice from "../scenes/Scheduler/schedulerSlice/schedulerSlice";

import TreeDrowpSlice from "../General/Components/TreeToDrowp/Slice/TreeDrowpSlice";
import PersonCartableSlice from "../scenes/PersonFroms/slice/PersonCartableSlice";
const store = configureStore({
  reducer: {
    general: GeneralSlice,
    schedulerSlice:schedulerSlice,
    chart: ChartSlice,
    addPersonInfo: UserSlice,
    treeDrowp: TreeDrowpSlice,
    personCartable:PersonCartableSlice
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
      
    })
});
export default store;
